import browserName from "@frameworks/web/utils/browserName";
export var inputfield = {
    name: "",
    email: "",
    mobile: "",
    selectoption: "",
    comment: "",
    imgs: [],
};
var FeedbackEntity = /** @class */ (function () {
    function FeedbackEntity(name, email, mobile, selectoption, comment, imgs, page, accode) {
        this.name = name;
        this.email = email;
        this.mobile = mobile;
        this.selectoption = selectoption;
        this.comment = comment;
        this.imgs = imgs;
        this.mod = "GEN";
        this.rtg = 0;
        this.pg = !!page ? page : "Homepage";
        this.url = window.location.href;
        this.ptf = "EWIN";
        this.brw = browserName().browserName;
        this.accode = !!accode ? accode : "Guest User";
    }
    return FeedbackEntity;
}());
export { FeedbackEntity };
